import { createSlice } from "@reduxjs/toolkit";

const errorSlice = createSlice({
  name: "error",
  initialState: {
    openAIApiError: null,
  },
  reducers: {
    setOpenAIError: (state, action) => {
      state.openAIApiError = action.payload;
    },
    clearErrorMessage: (state, action) => {
      state.openAIApiError = null;
    },
  },
});

export const { setOpenAIError, clearErrorMessage } = errorSlice.actions;
export default errorSlice.reducer;
